module.exports = __webpack_public_path__ + "static/media/2.dcd59013.svg";